var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.vueAppClasses, attrs: { id: "app" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("router-view", { on: { setAppClasses: _vm.setAppClasses } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "loading-bg" } }, [
      _c("div", { staticClass: "loadingText" }, [_vm._v("Carregando...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }